import React from 'react';
import PropTypes from 'prop-types';

const AlertInfo = ({ width = '24' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={width}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 0C5.37253 0 0 5.37253 0 12.0004C0 18.6275 5.37253 24 12 24C18.6274 24 24 18.6275 24 12.0004C24 5.37253 18.6274 0 12 0ZM11.9957 5.10059C13.0005 5.10059 13.8155 5.91535 13.8155 6.92043C13.8155 7.92566 13.0005 8.74033 11.9957 8.74033C10.9905 8.74033 10.1754 7.92566 10.1754 6.92043C10.1753 5.91535 10.9905 5.10059 11.9957 5.10059ZM14.7938 19.0914C14.9754 19.0914 15.1228 18.9439 15.1228 18.7621H15.1229V18.0869C15.1229 17.9051 14.9754 17.7577 14.7939 17.7577H13.7459V10.3488C13.7459 10.1669 13.5984 10.0195 13.417 10.0195H13.4064H10.2575H9.16727C8.98571 10.0195 8.83826 10.1669 8.83826 10.3488V11.0247C8.83826 11.2066 8.98571 11.3541 9.16727 11.3541H10.2575V17.7577H9.1998C9.0182 17.7577 8.87089 17.9051 8.87089 18.0869V18.7621C8.87089 18.9439 9.01824 19.0914 9.1998 19.0914H10.2575H13.7353H14.7938Z"
      fill="#D68309"
    />
  </svg>
);

AlertInfo.propTypes = {
  width: PropTypes.string,
};

export default AlertInfo;
